<template>
  <div class="cardContainer">
    <lk-card title='患者用药指导及注意事项'>
      <lk-form :label-width='120' label-position='right' :model='goodsUsageInfo' :rules='guidanceValide'>
        <lk-row :gutter='16' v-for="(item, index) in textList" :key="index">
          <lk-col class="MGCon" >
            <lk-form-item :label='item.text' :prop="item.model">
              <lk-input
                v-model="goodsUsageInfo[item.model]"
                v-if="able"
                type="textarea"
                :autosize=true
                size="small"
                :maxlength="5000"
                clearable
                placeholder="请输入，最多支持5000字符"
                style="paddingRight: 40px"
              />
              <span
                v-else
                v-html="goodsUsageInfo[item.model]
                  ? goodsUsageInfo[item.model].replace(/(\r\n|\n|\r)/gm, '<br/>')
                  : null"
              ></span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16' style="paddingTop: 20px" v-if="showFAQ">
          <lk-col class="cardUrlCon">
            <lk-form-item label='药学服务卡：'>
              <Uploader
                v-model.trim='goodsUsageInfo.cardUrl'
                :maxSize='10'
                :able='able'
                :format='format'
              ></Uploader>
            </lk-form-item>
            <span class="cardText" v-if="haveImg && able">支持图片、pdf格式，大小不超过10M</span>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16' class="FAQCon" v-if="showFAQ">
           <div class="FAQTitle">
            <span>FAQ</span>
          </div>
          <lk-table
            :columns='columns'
            :data='goodsUsageInfo.goodsBaseFaqVoList'
            border
          ></lk-table>
        </lk-row>
        </lk-form>
    </lk-card>
  </div>
</template>

<script>
import Uploader from '../../Uploader.vue';
// import utils from '../../libs/utils';

export default {
  name: 'MedicationGuidance',
  components: {
    Uploader,
  },
  props: {
    goodsForm: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
    able: {
      type: Boolean,
      default: false,
    },
    showFAQ: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'goodsForm',
    event: 'change',
  },
  computed: {
    haveImg() {
      return !this.goodsUsageInfo.cardUrl || this.goodsUsageInfo.cardUrl == '';
    },
  },
  watch: {
    goodsForm: {
      handler() {
        this.goodsUsageInfo = this.goodsForm;
        // 新增和编辑的时候初始化两条数据
        if (!this.goodsUsageInfo.goodsBaseFaqVoList || (this.able && this.goodsUsageInfo.goodsBaseFaqVoList.length === 0)) {
          this.$set(this.goodsUsageInfo, 'goodsBaseFaqVoList', [
            {
              questionType: '',
              answer: '',
            },
            {
              questionType: '',
              answer: '',
            },
          ]);
        }
      },
      deep: true,
      immediate: true,
    },
    goodsUsageInfo: {
      handler(val) {
        this.$emit('change', val);
      },
      deep: true,
    },
  },
  data() {
    const validateCode = (rule, value, callback) => {
      if (value.length > 5000) {
        callback(new Error('超出最大字符数限制'));
      } else {
        callback();
      }
    };
    return {
      columns: [
        {
          title: '问题标题',
          width: 450,
          render: (h, { row, index }) => (this.able ? h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.goodsUsageInfo.goodsBaseFaqVoList[index].questionType = e.target.value;
              },
            },
            props: {
              value: row.questionType,
              maxlength: 30,
            },
          }) : h('span', this.goodsUsageInfo.goodsBaseFaqVoList[index].questionType)),
        },
        {
          title: '药师回复',
          minWidth: 430,
          render: (h, { row, index }) => (this.able ? h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.goodsUsageInfo.goodsBaseFaqVoList[index].answer = e.target.value;
              },
            },
            props: {
              value: row.answer,
              maxlength: 200,
              type: 'textarea',
              autosize: true,
            },
          }) : h('span', this.goodsUsageInfo.goodsBaseFaqVoList[index].answer)),
        },
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            const idx = this.goodsUsageInfo.goodsBaseFaqVoList.length - 1;
            return h('div', [
              h('lk-button', {
                props: {
                  type: 'text',
                  disabled: !this.able || idx === 0,
                },
                on: {
                  click: () => {
                    this.onDelete(params.index);
                  },
                },
              }, '删除'),
              idx === params.index
                ? h('lk-button', {
                  props: {
                    type: 'text',
                    disabled: !this.able,
                  },
                  on: {
                    click: () => {
                      this.handlerAddClick();
                    },
                  },
                }, '新增') : '',
            ]);
          },
        },
      ],
      format: [
        'image/png',
        'image/jpeg',
        'jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp',
        'application/pdf',
        'pdf',
      ],
      textList: [ // 文本输入框
        {
          text: '不良反应：',
          model: 'adrs',
        },
        {
          text: '用法说明：',
          model: 'instructions',
        },
        {
          text: '用药注意事项：',
          model: 'goodsUsageAttention',
        },
        {
          text: '用药护理方案：',
          model: 'goodsUsageNursing',
        },
        {
          text: '用药金融方案：',
          model: 'goodsUsageFinance',
        },
      ],
      goodsUsageInfo: {
        cardUrl: '',
      },
      guidanceValide: {
        goodsUsageAttention: [{
          required: false, validator: validateCode, trigger: 'change', transform: value => (value ? value.trim() : ''),
        }],
        goodsUsageNursing: [{
          required: false, validator: validateCode, trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
        goodsUsageFinance: [{
          required: false, validator: validateCode, trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
      },
    };
  },
  methods: {
    handlerAddClick() {
      this.goodsUsageInfo.goodsBaseFaqVoList.push({
        questionType: '',
        answer: '',
      });
    },
    onDelete(index) {
      this.goodsUsageInfo.goodsBaseFaqVoList.splice(index, 1);
    },
  },

  created() {
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
  .cardContainer{
    margin-bottom: 16px;
  }
  .cardUrlCon {
    display: flex;
    .cardText {
      display: block;
      padding:6px 0 0 4px;
    }
  }
  .FAQCon {
    padding: 20px 40px 60px 40px;
  }
</style>
